import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './EmptyCollectionScreen.styled';
import { useIsTopBannerVisible } from '@/hooks/useIsTopBannerVisible';

interface EmptyCollectionScreenProps {
  isOwner: boolean;
}

export const EmptyCollectionScreen = ({
  isOwner,
}: EmptyCollectionScreenProps) => {
  const { t } = useTranslation();
  const isTopBannerVisible = useIsTopBannerVisible();

  return (
    <S.EmptyCollectionScreen
      $isTopBannerVisible={isTopBannerVisible}
      data-testid="collections-empty"
    >
      <S.Title>{t('bookmark_collections.empty_collection_title')}</S.Title>
      {isOwner ? (
        <S.Description>
          {t('bookmark_collections.empty_collection_description')}
        </S.Description>
      ) : null}
    </S.EmptyCollectionScreen>
  );
};
